@if (!initData.config.isPromoHubExist) {
    <lh-navigation-layout-page
        class="portal-wrapper-fw"
        highlightProduct="promo"
        id="mypromotions-page"
        sourceItem="mypromotions"
        [topMenuVisibility]="newAccountMenuService.hideTopMenu('mypromotions')"
        (onBack)="routeToList()">
        <div class="promotion-header">
            <pt-scrolling-navigation [items]="initData.viewModel.tabItems" (onTabSelected)="onTabSelected($event)"> </pt-scrolling-navigation>
        </div>
        <ng-container *ngTemplateOutlet="detailview"></ng-container>
    </lh-navigation-layout-page>
}
@if (initData.config.isPromoHubExist) {
    <div
        class="portal-wrapper-fw"
        id="mypromotions-page"
        [ngClass]="{ 'promo-hub': !(isEpcotEnabled() && isMobile), 'epcot-background-color': isEpcotEnabled() }">
        @if (!isMobile) {
            <div class="portal-center-wrapper">
                <div
                    class="header-ctrl-wrapper promo-hub-top-nav"
                    [ngClass]="{ 'epcot-header': isEpcotEnabled(), 'header-ctrl-light-ph': !isEpcotEnabled() }">
                    <div class="header-ctrl d-flex justify-content-between align-items-center">
                        <div class="header-ctrl-l">
                            <span class="ui-icon ui-icon-size-lg ui-back theme-left" (click)="goBack()"></span>
                        </div>
                        <div class="header-ctrl-txt">{{ initData.content.myPromotion.title }}</div>
                    </div>
                </div>
                <ng-container *ngTemplateOutlet="detailview"></ng-container>
            </div>
        }
        @if (isMobile) {
            <vn-header-bar
                [ngClass]="{
                    'header-ctrl-light-ph': !isMobile,
                    'epcot-header-mobile': isEpcotEnabled(),
                    'hideBack': !initData.config.hideCloseButton,
                }"
                [showBack]="initData.config.hideCloseButton ? true : !this.isMobile"
                [showClose]="initData.config.hideCloseButton ? false : this.isMobile"
                [title]="initData.content.myPromotion.title"
                (onBack)="goBack()"
                (onClose)="goBack()">
            </vn-header-bar>
            <div class="portal-center-wrapper">
                <ng-container *ngTemplateOutlet="detailview"></ng-container>
            </div>
        }
    </div>
}
<ng-template #detailview>
    <div class="promotions-detail promotion-container" [class.iframe-detail]="hasIframe">
        @if (initData.promotionItem && !isTopPromotion) {
            <div class="cards width-restricted-medium">
                <div class="vn-profile-img">
                    <img class="top-img profile-img-width" [vnProfilesSrc]="initData.promotionItem.imageUrl" />
                </div>
                <div class="card">
                    <div class="promotion-detail promotion-border-bottom">
                        <h2 class="promotion-main-headline detail" [innerHtml]="initData.promotionItem.imageHeadline"></h2>
                        <div class="promotion-body" [vnDynamicHtml]="initData.promotionItem.shortDescription"></div>
                        @for (cta of initData.promotionItem.ctas; track $index) {
                            <a class="promotion-link" (click)="ctaClick(cta)">
                                <span class="promotion-span" [innerHtml]="cta.text"></span>
                                <i class="theme-right"></i>
                            </a>
                        }
                        @for (cta of initData.promotionItem.smartCtas; track $index) {
                            <div class="pb-1" [vnDynamicHtml]="cta"></div>
                        }
                    </div>
                    <div class="promotion-detail">
                        <h2 class="promotion-headline detail" [innerHtml]="initData.promotionItem.detailsHeadline"></h2>
                        <div class="promotion-body" [vnDynamicHtml]="initData.promotionItem.detailsDescription"></div>
                    </div>
                </div>
                @if (initData.promotionItem.showTaCs) {
                    <div class="promotion-tac-header" [ngClass]="{ 'epcot-text-color epcot-tac-arrow': isEpcotEnabled() }" (click)="toggleTac()">
                        <span [innerHtml]="initData.promotionItem.tacTitle"></span>
                        <i [class.theme-down]="!tacExpanded" [class.theme-up]="tacExpanded"></i>
                    </div>
                }
                <div
                    class="promotion-tac-body pc-txt"
                    [hidden]="!tacExpanded"
                    [innerHtml]="initData.promotionItem.termsAndConditions | trustAsHtml"
                    [ngClass]="{ 'epcot-text-color': isEpcotEnabled() }"></div>
            </div>
        }
        @if (!initData.promotionItem && !isTopPromotion) {
            <div class="theme-info-i invalid-promotion" [innerHtml]="initData.content.messages.messages.invalidPromotion"></div>
        }
        @if (hasIframe) {
            <div id="iframe-promotions">
                <iframe id="my-promotions-iframe" [src]="iframeUrl | trustAsResourceUrl"></iframe>
            </div>
        }
        @if (isTopPromotion && !user.isAuthenticated) {
            <div class="login-prompt cards">
                <div class="card">
                    <h2 [innerHtml]="initData.content.loginPrompt.title"></h2>
                    <div [innerHtml]="initData.content.loginPrompt.text | trustAsHtml"></div>
                    <div class="btn btn-primary login" [innerHtml]="initData.content.loginPrompt.messages.buttonLogin" (click)="goToLogin()"></div>
                </div>
            </div>
        }
    </div>
</ng-template>
